import {Svg, type SvgProps} from './Svg';

export function TransferImage(props: SvgProps) {
	return (
		<Svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 610 138"
			fill="none"
			{...props}
		>
			<path
				fill="#63269c"
				d="M301.355 71.629c0 36.441-4.632 65.983-10.346 65.983-5.715 0-10.347-29.542-10.347-65.983 0-36.442 4.632-65.983 10.347-65.983 5.714 0 10.346 29.541 10.346 65.983z"
			/>
			<path
				fill="#5c238f"
				d="M284.389 71.62c0 36.441-5.069 65.983-11.322 65.983-6.254 0-11.323-29.541-11.323-65.983 0-36.442 5.069-65.983 11.323-65.983 6.253 0 11.322 29.541 11.322 65.983z"
			/>
			<path
				fill="#4a1c74"
				d="M265.044 71.63c0 36.441-5.856 65.983-13.08 65.983-7.223 0-13.079-29.542-13.079-65.983 0-36.442 5.856-65.984 13.079-65.984 7.224 0 13.08 29.542 13.08 65.984z"
			/>
			<path
				fill="#3b155e"
				d="M234.395 70.893c-3.498 36.271-14.08 65.553-23.634 65.405-9.555-.149-14.465-29.673-10.966-65.944 3.498-36.27 14.08-65.553 23.634-65.404 9.555.149 14.465 29.673 10.966 65.943z"
			/>
			<path
				fill="#391459"
				d="M144.475 68.112c5.624-36.228 21.578-65.31 35.636-64.958 14.057.353 20.894 30.007 15.271 66.234-5.624 36.228-21.579 65.31-35.636 64.958-14.057-.353-20.895-30.007-15.271-66.234z"
			/>
			<path
				fill="#29282d"
				d="M11.023 66.62C16.646 30.392 49.452 1.732 84.296 2.606c34.844.874 58.531 30.95 52.908 67.178-5.624 36.227-38.43 64.887-73.273 64.013-34.844-.873-58.532-30.95-52.908-67.177z"
			/>
			<path
				fill="#a238ff"
				d="M598.975 65.596C593.351 29.368 561.244.69 527.261 1.543c-33.983.852-56.973 30.911-51.35 67.139 5.624 36.227 37.731 64.905 71.714 64.052 33.983-.852 56.973-30.911 51.35-67.138z"
			/>
			<path
				fill="#000"
				d="M300.578 72.015c0 36.442 5.069 65.983 11.322 65.983s11.323-29.541 11.323-65.983c0-36.442-5.07-65.983-11.323-65.983s-11.322 29.541-11.322 65.983z"
			/>
			<path
				fill="#7430b4"
				d="M300.578 72.015c0 36.442 5.069 65.983 11.322 65.983s11.323-29.541 11.323-65.983c0-36.442-5.07-65.983-11.323-65.983s-11.322 29.541-11.322 65.983z"
			/>
			<path
				fill="#000"
				d="M322.441 72.017c0 36.441 5.855 65.983 13.079 65.983s13.08-29.542 13.08-65.983c0-36.442-5.856-65.983-13.08-65.983s-13.079 29.541-13.079 65.983z"
			/>
			<path
				fill="#8234ca"
				d="M322.441 72.017c0 36.441 5.855 65.983 13.079 65.983s13.08-29.542 13.08-65.983c0-36.442-5.856-65.983-13.08-65.983s-13.079 29.541-13.079 65.983z"
			/>
			<path
				fill="#000"
				d="M348.204 72.183c1.545 36.293 7.802 65.679 13.976 65.637s9.927-29.498 8.382-65.79c-1.544-36.293-7.801-65.68-13.976-65.637-6.174.042-9.927 29.498-8.382 65.79z"
			/>
			<path
				fill="#8030c9"
				d="M348.204 72.183c1.545 36.293 7.802 65.679 13.976 65.637s9.927-29.498 8.382-65.79c-1.544-36.293-7.801-65.68-13.976-65.637-6.174.042-9.927 29.498-8.382 65.79z"
			/>
			<path
				fill="#000"
				d="M375.599 71.29c3.498 36.27 14.08 65.552 23.635 65.404 9.554-.149 14.464-29.673 10.966-65.944-3.499-36.27-14.08-65.553-23.635-65.404S372.1 35.018 375.599 71.289z"
			/>
			<path
				fill="#8b35da"
				d="M375.599 71.29c3.498 36.27 14.08 65.552 23.635 65.404 9.554-.149 14.464-29.673 10.966-65.944-3.499-36.27-14.08-65.553-23.635-65.404S372.1 35.018 375.599 71.289z"
			/>
			<path
				fill="#000"
				d="M465.521 68.509c-5.623-36.228-21.578-65.31-35.636-64.958-14.057.353-20.894 30.007-15.27 66.234 5.623 36.228 21.578 65.31 35.635 64.958 14.058-.353 20.895-30.007 15.271-66.234z"
			/>
			<path
				fill="#9a3eef"
				d="M465.521 68.509c-5.623-36.228-21.578-65.31-35.636-64.958-14.057.353-20.894 30.007-15.27 66.234 5.623 36.228 21.578 65.31 35.635 64.958 14.058-.353 20.895-30.007 15.271-66.234z"
			/>
			<path
				fill="#0f0d13"
				fillRule="evenodd"
				d="M563.706 38.615c-1.045.004-1.986 2.315-2.628 5.989-1.041-6.333-2.734-10.452-4.638-10.452-2.268 0-4.231 5.823-5.158 14.28-.913-6.154-2.292-10.079-3.833-10.079-2.164 0-4.005 7.718-4.687 18.48-1.281-5.517-3.136-8.98-5.192-8.98-2.057 0-3.912 3.463-5.193 8.98-.682-10.762-2.522-18.48-4.686-18.48-1.546 0-2.925 3.925-3.833 10.078-.933-8.456-2.896-14.28-5.163-14.28-1.909 0-3.598 4.12-4.638 10.453-.648-3.672-1.585-5.989-2.63-5.989-1.949 0-3.529 8.02-3.529 17.913s1.58 17.912 3.529 17.912c.799 0 1.541-1.355 2.129-3.643.938 8.354 2.886 14.095 5.139 14.095 1.747 0 3.308-3.449 4.358-8.888.721 10.345 2.522 17.684 4.633 17.684 1.33 0 2.537-2.91 3.425-7.645 1.07 9.777 3.558 16.625 6.454 16.625 2.895 0 5.379-6.848 6.453-16.625.894 4.735 2.101 7.645 3.426 7.645 2.11 0 3.916-7.339 4.633-17.684 1.05 5.44 2.616 8.888 4.358 8.888 2.252 0 4.201-5.74 5.138-14.095.594 2.283 1.33 3.643 2.13 3.643 1.948 0 3.529-8.019 3.529-17.912 0-9.89-1.579-17.906-3.526-17.913zm0 0h-.003.005zM504.84 62.72c1.117 0 2.022-3.561 2.022-7.955s-.905-7.956-2.022-7.956c-1.116 0-2.022 3.562-2.022 7.956s.906 7.955 2.022 7.955zm67.474-7.955c0 4.394-.905 7.955-2.022 7.955s-2.022-3.561-2.022-7.955.905-7.956 2.022-7.956 2.022 3.562 2.022 7.956z"
				clipRule="evenodd"
			/>
			<path
				fill="#fff"
				d="M101.885 66.372c0-7.393-.398-14.09-1.042-18.95-.25-1.886-.535-3.496-.85-4.762a83.494 83.494 0 0 0-3.286-.388c-4.312-.429-9.637-.683-15.402-.683-5.766 0-11.09.253-15.401.683a83.539 83.539 0 0 0-3.285.388c-.315 1.266-.602 2.876-.852 4.761-.643 4.862-1.041 11.558-1.041 18.951 0 6.254.284 12.01.762 16.577-1.777-.99-3.966-1.575-6.334-1.575-5.94 0-10.754 3.676-10.754 8.21 0 4.536 4.815 8.211 10.754 8.211 5.28 0 9.672-2.904 10.581-6.735 1.271-4.135 2.16-13.631 2.16-24.687 0-7.09-.366-13.537-.963-18.341 4.118.37 9.058.584 14.373.584 5.314 0 10.255-.216 14.373-.584-.598 4.804-.964 11.252-.964 18.341 0 6.254.285 12.01.762 16.577-1.777-.99-3.965-1.574-6.333-1.574-5.94 0-10.754 3.675-10.754 8.21s4.814 8.21 10.754 8.21c5.28 0 9.671-2.904 10.58-6.735 1.272-4.135 2.161-13.63 2.161-24.686z"
			/>
		</Svg>
	);
}
